import React, { useState, useEffect } from 'react';
import { Layout, Dropdown, Button, theme, Modal, Radio, message, Spin, Input, Tabs, Menu } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
  TrophyOutlined,
  TeamOutlined,
  PlayCircleOutlined,
  UserOutlined as PlayerIcon,
  BarChartOutlined,
  SettingOutlined,
  UnorderedListOutlined,
  PlusOutlined,
  CalendarOutlined,
  PieChartOutlined,
  FileTextOutlined,
  ToolOutlined,
  SkinOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, apiClient } from '../contexts/AuthContext';
import { getCurrentTheme, getAvailableThemes, setTheme } from '../config/themeConfig';
import MemberList from './MemberList';
import TeacherList from './TeacherList';
import StudentArchive from './StudentArchive';
import StudentProfile from './StudentProfile';
import CustomerList from './CustomerList';
import Classperiod from './Classperiod';
import Academic from './Academic';
import Course from './Course';
import Community from './Community';
import ScheduCourse from './ScheduCourse';
import CurriculumSystem from './CurriculumSystem';
import MyCourse from './MyCourse';
import AiLearning from './AiLearning';
import BulletinBoard from './BulletinBoard';
import StageEvaluation from './StageEvaluation';
import StarPrice from './StarPrice';
import TrainingPlan from './TrainingPlan';
import EventPublish from './EventPublish';
import EventComplete from './EventComplete';
import VenueDashboard from './VenueDashboard';
import VenueMonitor from './VenueMonitor';

const MAX_TABS_COUNT = 8; // 最大标签页数量

const { Header, Sider, Content } = Layout;

const portalList = ({ user }) => (
    <div className="menu-item-content">
      <h2>体育项目列表</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示体育项目列表内容...</p>
      </div>
    </div>
);

const portalAdd = ({ user }) => (
    <div className="menu-item-content">
      <h2>添加体育项目</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示添加体育项目的表单...</p>
      </div>
    </div>
);

const TeamsList = ({ user }) => (
    <div className="menu-item-content">
      <h2>团队列表</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示团队列表内容...</p>
      </div>
    </div>
);

const TeamsAdd = ({ user }) => (
    <div className="menu-item-content">
      <h2>添加团队</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示添加团队的表单...</p>
      </div>
    </div>
);

const MatchesList = ({ user }) => (
    <div className="menu-item-content">
      <h2>比赛列表</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示比赛列表内容...</p>
      </div>
    </div>
);

const MatchesSchedule = ({ user }) => (
    <div className="menu-item-content">
      <h2>比赛安排</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示比赛安排内容...</p>
      </div>
    </div>
);

const PlayersList = ({ user }) => (
    <div className="menu-item-content">
      <h2>运动员列表</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示运动员列表内容...</p>
      </div>
    </div>
);

const PlayersAdd = ({ user }) => (
    <div className="menu-item-content">
      <h2>添加运动员</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示添加运动员的表单...</p>
      </div>
    </div>
);

const StatisticsOverview = ({ user }) => (
    <div className="menu-item-content">
      <h2>统计概览</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示统计概览内容...</p>
      </div>
    </div>
);

const StatisticsReports = ({ user }) => (
    <div className="menu-item-content">
      <h2>统计报告</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示统计报告内容...</p>
      </div>
    </div>
);

const SettingsProfile = ({ user }) => {
  // 从localStorage获取用户信息
  const localStorageUser = JSON.parse(localStorage.getItem('user')) || {};
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '18px', fontWeight: 'bold', margin: '8px 0' }}>
          {localStorageUser.name || user?.name}
        </p>
        <p style={{ fontSize: '16px', color: '#666', margin: '4px 0' }}>
          {localStorageUser.customerName || '未知校区'}
        </p>
      </div>
    </div>
  );
};

const ChangePassword = ({ user }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleChangePassword = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      messageApi.error('请填写所有字段');
      return;
    }

    if (newPassword !== confirmPassword) {
      messageApi.error('新密码和确认密码不一致');
      return;
    }

    if (newPassword.length < 6) {
      messageApi.error('密码长度至少6位');
      return;
    }

    try {
      setLoading(true);
      // 从localStorage获取用户信息
      const localStorageUser = JSON.parse(localStorage.getItem('user')) || {};
      const loginId = localStorageUser.username;

      const response = await apiClient.post('/portal-server-prod/user/login/v1/change-password', {
        loginId,
        oldPassword,
        newPassword
      });

      if (response.data) {
        messageApi.success('密码修改成功');
        // 清空表单
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        messageApi.error('密码修改失败');
      }
    } catch (error) {
      console.error('Password change error:', error);
      messageApi.error('密码修改失败: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px 0' }}>
      {contextHolder}
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>旧密码:</label>
        <Input.Password 
          value={oldPassword} 
          onChange={(e) => setOldPassword(e.target.value)} 
          placeholder="请输入旧密码" 
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>新密码:</label>
        <Input.Password 
          value={newPassword} 
          onChange={(e) => setNewPassword(e.target.value)} 
          placeholder="请输入新密码" 
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>确认新密码:</label>
        <Input.Password 
          value={confirmPassword} 
          onChange={(e) => setConfirmPassword(e.target.value)} 
          placeholder="请再次输入新密码" 
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button 
          type="primary" 
          onClick={handleChangePassword} 
          loading={loading}
          style={{ width: '100%' }}
        >
          修改密码
        </Button>
      </div>
    </div>
  );
};

const SettingsSystem = ({ user }) => (
    <div className="menu-item-content">
      <h2>系统配置</h2>
      <p>当前用户：{user?.name} ({user?.role})</p>
      <div style={{ marginTop: 20 }}>
        <p>这里显示系统配置内容...</p>
      </div>
    </div>
);


// 注意：监测模式现在通过路由区分
// /venue/dashboard - PC端控制页面
// /venue/monitor - TV端大屏展示页面

// 递归查找菜单项是否在用户权限内
const findMenuItemByPath = (items, targetPath) => {
  for (const item of items) {
    if (item.path === targetPath) {
      return item;
    }
    if (item.children) {
      const found = findMenuItemByPath(item.children, targetPath);
      if (found) return found;
    }
  }
  return null;
};

// 检查用户是否有权限访问指定路径
const hasPermission = (menuItems, path) => {
  // 系统默认允许访问的路径（不需要在菜单中配置）
  const allowedPaths = ['/venue/dashboard', '/venue/monitor'];
  if (allowedPaths.includes(path)) {
    return true;
  }
  // 检查路径是否在菜单权限内
  return !!findMenuItemByPath(menuItems, path);
};

const Dashboard = () => {
  console.log('=== Dashboard 组件开始渲染 ===');

  const navigate = useNavigate();
  const location = useLocation();
  
  // 通过当前路由判断是否处于监测模式（TV端）
  const isMonitorMode = location.pathname === '/venue/monitor';

  const [collapsed, setCollapsed] = useState(() => {
    // 从localStorage恢复侧边栏折叠状态
    const savedCollapsed = localStorage.getItem('sidebarCollapsed');
    return savedCollapsed === 'true' ? true : false;
  });
  const [themeModalVisible, setThemeModalVisible] = useState(false);
  const [profileModalVisible, setProfileModalVisible] = useState(false);
  const [showPasswordChangeOnLoad, setShowPasswordChangeOnLoad] = useState(false);
  const [currentTheme, setCurrentTheme] = useState('green');
  const [activeTab, setActiveTab] = useState(() => {
    // 从localStorage恢复活动标签页状态
    const savedActiveTab = localStorage.getItem('activeTab');
    // 如果是监测模式，默认使用 monitor 路径
    const defaultPath = location.pathname === '/venue/monitor' ? '/venue/monitor' : '/venue/dashboard';
    return savedActiveTab || defaultPath;
  });
  const [tabs, setTabs] = useState(() => {
    // 从localStorage恢复标签页状态
    const savedTabs = localStorage.getItem('tabs');
    if (savedTabs) {
      try {
        let parsedTabs = JSON.parse(savedTabs);
        // 限制标签页数量，最多保留最近的MAX_TABS_COUNT个标签
        if (parsedTabs.length > MAX_TABS_COUNT) {
          parsedTabs = parsedTabs.slice(-MAX_TABS_COUNT); // 保留最后MAX_TABS_COUNT个标签
        }
        return parsedTabs;
      } catch (e) {
        console.error('Failed to parse tabs from localStorage', e);
      }
    }
    // 默认标签页 - 根据当前路由决定
    const isMonitor = location.pathname === '/venue/monitor';
    return [
      { key: isMonitor ? '/venue/monitor' : '/venue/dashboard', label: '大屏展示', path: isMonitor ? '/venue/monitor' : '/venue/dashboard' }
    ];
  });
  const [openKeys, setOpenKeys] = useState(() => {
    // 从localStorage恢复展开的菜单项
    const savedOpenKeys = localStorage.getItem('menuOpenKeys');
    if (savedOpenKeys) {
      try {
        return JSON.parse(savedOpenKeys);
      } catch (e) {
        console.error('Failed to parse openKeys from localStorage', e);
      }
    }
    return [];
  });
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [userMenuVisible, setUserMenuVisible] = useState(false);
  
  const { user, logout } = useAuth();
  const { token } = theme.useToken();

  // 权限验证：检查 activeTab 是否在用户权限内
  useEffect(() => {
    if (!user || !user.menuData) return;

    const savedActiveTab = localStorage.getItem('activeTab');
    
    // 如果有保存的 activeTab，检查权限
    if (savedActiveTab) {
      const hasAccess = hasPermission(user.menuData, savedActiveTab);
      
      if (!hasAccess) {
        // 权限不匹配，清除登录状态并跳转到登录页
        message.error('您的权限已变更，请重新登录');
        logout();
        
        // 清除所有用户相关的 localStorage 数据
        localStorage.removeItem('tabs');
        localStorage.removeItem('activeTab');
        localStorage.removeItem('menuOpenKeys');
        localStorage.removeItem('sidebarCollapsed');
        localStorage.removeItem('customerList');
        localStorage.removeItem('STAR_LEVEL');
        localStorage.removeItem('customerBandSelectedId');
        localStorage.removeItem('single_member_scheduler_selected_member');
        
        // 清除以 classList_ 开头的缓存
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('classList_')) {
            localStorage.removeItem(key);
          }
        });
        
        // 清除以 teacher_ 开头的缓存
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('teacher_')) {
            localStorage.removeItem(key);
          }
        });
        
        // 清除以 trainingPlan_ 开头的缓存
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('trainingPlan_')) {
            localStorage.removeItem(key);
          }
        });
        
        navigate('/login');
      }
    }
  }, [user, navigate, logout]);

  // 示例：API 调用函数
  const fetchData = async () => {
    try {
      // 使用 apiClient 发起请求，它会自动添加 accessToken 请求头
      const response = await apiClient.post('/portal-server-prod/some/api/endpoint', {
        // 请求参数
      });
      
      // 处理响应数据
      console.log('API Response:', response.data);
    } catch (error) {
      console.error('API Error:', error);
      message.error('获取数据失败');
    }
  };

  // 只使用后端提供的菜单数据，如果没有则使用空数组（不显示硬编码菜单）
  const finalMenuItems = user?.menuData && user.menuData.length > 0 ? user.menuData : [];

  // 图标映射
  const iconMap = {
    DashboardOutlined: <DashboardOutlined />,
    TrophyOutlined: <TrophyOutlined />,
    TeamOutlined: <TeamOutlined />,
    PlayCircleOutlined: <PlayCircleOutlined />,
    UserOutlined: <PlayerIcon />,
    BarChartOutlined: <BarChartOutlined />,
    SettingOutlined: <SettingOutlined />,
    UnorderedListOutlined: <UnorderedListOutlined />,
    PlusOutlined: <PlusOutlined />,
    CalendarOutlined: <CalendarOutlined />,
    PieChartOutlined: <PieChartOutlined />,
    FileTextOutlined: <FileTextOutlined />,
    ToolOutlined: <ToolOutlined />
  };

  // 递归处理菜单项，添加图标
  const processMenuItems = (items) => {
    return items.map(item => {
      const processedItem = {
        ...item,
        icon: iconMap[item.icon] || null,
      };
      
      // 保留自定义属性
      if (item.apiUrl) {
        processedItem.apiUrl = item.apiUrl;
      }
      if (item.apiParams) {
        processedItem.apiParams = item.apiParams;
      }
      
      // 递归处理子菜单
      if (item.children) {
        processedItem.children = processMenuItems(item.children);
      }
      
      return processedItem;
    });
  };

  const processedMenuItems = processMenuItems(finalMenuItems);

  // 获取当前主题配置
  const customTheme = getCurrentTheme();

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'green';
    setCurrentTheme(savedTheme);
  }, []);

  // 监听路由变化，确保标签同步
  useEffect(() => {
    // 检查是否需要显示密码修改提示
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    if (userData.needChangePassword) {
      setShowPasswordChangeOnLoad(true);
      setProfileModalVisible(true);
    }
    
    // 查找当前路径对应的菜单项
    const findMenuItemByPath = (items, targetPath) => {
      for (const item of items) {
        if (item.path === targetPath) {
          return item;
        }
        if (item.children) {
          const found = findMenuItemByPath(item.children, targetPath);
          if (found) return found;
        }
      }
      return null;
    };

    // 智能提取页面标题的函数
    const extractTitleFromPath = (path) => {
      // 移除开头的斜杠和可能的参数部分
      let cleanPath = path.replace(/^\//, '').split('/')[0];
      
      // 如果路径包含多个部分，尝试获取有意义的部分
      const pathParts = path.split('/').filter(part => part.length > 0);
      if (pathParts.length >= 2) {
        // 使用倒数第二个和最后一个部分作为标题基础
        const parentPart = pathParts[pathParts.length - 2];
        const childPart = pathParts[pathParts.length - 1];
        
        // 简单的中文转换规则
        const translations = {
          'member': '会员',
          'list': '列表',
          'coach': '教练',
          'customer': '客户',
          'classperiod': '课时',
          'academic': '体测',
          'archive': '档案',
          'portal': '体育',
          'teams': '团队',
          'matches': '比赛',
          'players': '运动员',
          'statistics': '统计',
          'settings': '设置',
          'profile': '资料',
          'system': '系统'
        };
        
        // 尝试翻译各部分
        const translatedParent = translations[parentPart] || parentPart;
        const translatedChild = translations[childPart] || childPart;
        
        // 组合标题
        if (translatedParent && translatedChild) {
          return `${translatedParent}${translatedChild}`;
        }
      }
      
      // 如果没有找到合适的翻译，使用默认方法
      return cleanPath || '未知页面';
    };

    // 如果当前路径没有对应标签，则添加
    const currentTab = tabs.find(tab => tab.path === location.pathname);
    if (!currentTab && location.pathname !== '/') {
      const menuItem = findMenuItemByPath(processedMenuItems, location.pathname);
      if (menuItem) {
        const newTab = { 
          key: menuItem.path, 
          label: menuItem.label, 
          path: menuItem.path 
        };
        setTabs(prevTabs => {
          let updatedTabs = [...prevTabs, newTab];
          // 限制标签页数量，最多保留最近的MAX_TABS_COUNT个标签
          if (updatedTabs.length > MAX_TABS_COUNT) {
            updatedTabs = updatedTabs.slice(-MAX_TABS_COUNT); // 保留最后MAX_TABS_COUNT个标签
          }
          // 保存标签页状态到localStorage
          localStorage.setItem('tabs', JSON.stringify(updatedTabs));
          return updatedTabs;
        });
      } else {
        // 智能创建标签页，不再使用硬编码的特殊路径映射
        const pageTitle = extractTitleFromPath(location.pathname);
        const newTab = { 
          key: location.pathname, 
          label: pageTitle, 
          path: location.pathname 
        };
        setTabs(prevTabs => {
          let updatedTabs = [...prevTabs, newTab];
          // 限制标签页数量，最多保留最近的MAX_TABS_COUNT个标签
          if (updatedTabs.length > MAX_TABS_COUNT) {
            updatedTabs = updatedTabs.slice(-MAX_TABS_COUNT); // 保留最后MAX_TABS_COUNT个标签
          }
          // 保存标签页状态到localStorage
          localStorage.setItem('tabs', JSON.stringify(updatedTabs));
          return updatedTabs;
        });
      }
    }
    
    // 更新活动标签
    if (location.pathname !== '/') {
      setActiveTab(location.pathname);
      // 保存活动标签状态到localStorage
      localStorage.setItem('activeTab', location.pathname);
    }
  }, [location.pathname]);

  const handleMenuClick = async (pathOrEvent) => {
    // 处理 Radio.Group 直接传值的情况
    const path = typeof pathOrEvent === 'string' ? pathOrEvent : pathOrEvent?.key;
    if (!path) return;
    
    // 根据 path 查找菜单项
    const findMenuItemByPath = (items, targetPath) => {
      for (const item of items) {
        if (item.path === targetPath) {
          return item;
        }
        if (item.children) {
          const found = findMenuItemByPath(item.children, targetPath);
          if (found) return found;
        }
      }
      return null;
    };

    const menuItem = findMenuItemByPath(processedMenuItems, path);
    if (menuItem) {
      // 如果菜单项有apiUrl属性，则先请求后端接口
      if (menuItem.apiUrl) {
        try {
          setLoading(true);
          const response = await apiClient.get(menuItem.apiUrl, {
            params: menuItem.apiParams || {}
          });
          console.log('API Response:', response.data);
        } catch (error) {
          console.error('API Error:', error);
          message.error('获取数据失败');
        } finally {
          setLoading(false);
        }
      }
      
      // 检查标签是否已经存在
      const tabExists = tabs.find(tab => tab.path === path);
      
      if (!tabExists) {
        // 如果标签不存在，则添加新标签
        const newTab = { 
          key: path, 
          label: menuItem.label, 
          path: path 
        };
        setTabs(prevTabs => {
          let updatedTabs = [...prevTabs, newTab];
          if (updatedTabs.length > MAX_TABS_COUNT) {
            updatedTabs = updatedTabs.slice(-MAX_TABS_COUNT);
          }
          localStorage.setItem('tabs', JSON.stringify(updatedTabs));
          return updatedTabs;
        });
      }
      
      // 设置为活动标签并导航
      setActiveTab(path);
      localStorage.setItem('activeTab', path);
      navigate(path);
    } else {
      // 处理未在菜单配置中定义的路径
      const tabExists = tabs.find(tab => tab.path === path);
      
      if (!tabExists) {
        // 智能提取页面标题
        const pathParts = path.split('/').filter(p => p);
        const lastPart = pathParts[pathParts.length - 1] || '';
        const label = lastPart || '新页面';
        
        const newTab = { 
          key: path, 
          label: label, 
          path: path
        };
        setTabs(prevTabs => {
          let updatedTabs = [...prevTabs, newTab];
          if (updatedTabs.length > MAX_TABS_COUNT) {
            updatedTabs = updatedTabs.slice(-MAX_TABS_COUNT);
          }
          localStorage.setItem('tabs', JSON.stringify(updatedTabs));
          return updatedTabs;
        });
      }
      
      setActiveTab(path);
      localStorage.setItem('activeTab', path);
      navigate(path);
    }
  };

  const handleLogout = async () => {
    try {
      // 调用登出接口
      await apiClient.post('/portal-server-prod/user/login/v1/logout');
    } catch (error) {
      console.error('登出接口调用失败:', error);
    } finally {
      // 无论接口调用成功与否，都执行本地登出操作
      logout();
      
      // 清除所有以 classList_ 开头的缓存
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('classList_')) {
          localStorage.removeItem(key);
        }
      });
      
      // 清除所有以 teacher_ 开头的缓存
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('teacher_')) {
          localStorage.removeItem(key);
        }
      });
      
      // 清除所有以 trainingPlan_ 开头的缓存
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('trainingPlan_')) {
          localStorage.removeItem(key);
        }
      });
      
      // 删除标签页信息和其他用户会话数据
      localStorage.removeItem('tabs');
      localStorage.removeItem('activeTab');
      localStorage.removeItem('menuOpenKeys');
      localStorage.removeItem('sidebarCollapsed');
      localStorage.removeItem('customerList');
      localStorage.removeItem('STAR_LEVEL');
      localStorage.removeItem('customerBandSelectedId');
      localStorage.removeItem('single_member_scheduler_selected_member');

      navigate('/login');
    }
  };

  const handleThemeChange = (themeName) => {
    if (setTheme(themeName)) {
      setCurrentTheme(themeName);
      // 不自动关闭模态框，让用户手动关闭
    }
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="theme" icon={<SkinOutlined />} onClick={() => setThemeModalVisible(true)}>
        主题设置
      </Menu.Item>
      <Menu.Item key="profile" icon={<UserOutlined />} onClick={() => setProfileModalVisible(true)}>
        个人资料
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  // 添加一个简单的测试组件来验证渲染
  const TestComponent = () => (
    <div style={{ padding: 20, background: '#f0f9ff', border: '1px solid #bae6fd' }}>
      <h3>测试组件 - Dashboard渲染成功!</h3>
      <p>如果看到这个，说明Dashboard组件正常渲染</p>
    </div>
  );

  return (
    <Layout className="dashboard-layout" style={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'row' }}>
      {/* 侧边栏 - 使用 antd Sider 组件 - 监测模式下隐藏 */}
      {!isMonitorMode && (
        <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        collapsedWidth={0}
        width={200}
        style={{
          background: customTheme.token.colorPrimary,
          overflowY: 'auto',
          flexShrink: 0,
        }}
      >
        <div className="logo" style={{ 
          height: 64, 
          display: 'flex',
          alignItems: 'center', 
          justifyContent: 'center',
          color: 'white',
          fontSize: collapsed ? 16 : 20,
          background: customTheme.token.colorPrimary,
        }}>
          {collapsed ? 'T' : '运动健康'}
        </div>
        {/* 使用自定义菜单组件替换 Menu，提高低版本兼容性 */}
        {/* 自定义菜单 - 带展开动画 */}
        <div style={{ padding: '8px 0' }}>
          {processedMenuItems.map(item => (
            <div key={item.key} style={{ marginBottom: '2px' }}>
              {/* 一级菜单标题 - 与侧边栏背景一致 */}
              <div
                onClick={() => {
                  const isOpen = openKeys.includes(item.key);
                  const newKeys = isOpen 
                    ? openKeys.filter(k => k !== item.key)
                    : [...openKeys, item.key];
                  setOpenKeys(newKeys);
                  localStorage.setItem('menuOpenKeys', JSON.stringify(newKeys));
                }}
                className="menu-level-1"
                style={{
                  padding: '10px 16px',
                  cursor: 'pointer',
                  background: openKeys.includes(item.key) ? 'rgba(255,255,255,0.08)' : 'transparent',
                  borderLeft: `3px solid ${openKeys.includes(item.key) ? customTheme.token.colorPrimary : 'transparent'}`,
                  display: 'block',
                  width: '100%',
                  transition: 'all 0.25s ease',
                }}
              >
                <span style={{ color: 'white', fontSize: 14 }}>
                  {item.icon && <span style={{ marginRight: 10 }}>{item.icon}</span>}
                  {!collapsed && (
                    <span>
                      {item.label}
                      <span 
                        className="menu-arrow"
                        style={{ 
                          float: 'right', 
                          marginRight: 8,
                          fontSize: 10,
                          opacity: 0.7,
                          transform: openKeys.includes(item.key) ? 'rotate(90deg)' : 'rotate(0deg)',
                          transition: 'transform 0.25s ease',
                        }}
                      >
                        ▶
                      </span>
                    </span>
                  )}
                </span>
              </div>
              
              {/* 二级菜单 - 带动画效果 */}
              {!collapsed && (
                <div
                  className="menu-level-2-container"
                  style={{
                    maxHeight: openKeys.includes(item.key) && item.children && item.children.length > 0 ? '500px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out',
                    background: 'rgba(0,0,0,0.15)',
                  }}
                >
                  {item.children && item.children.length > 0 && (
                    <div style={{ padding: '4px 0' }}>
                      {item.children.map((child, idx) => (
                        <div
                          key={child.key}
                          onClick={() => handleMenuClick(child.path)}
                          className="menu-level-2"
                          style={{
                            padding: '10px 16px 10px 44px',
                            cursor: 'pointer',
                            background: location.pathname === child.path ? 'rgba(255,255,255,0.2)' : 'transparent',
                            color: location.pathname === child.path ? 'white' : 'rgba(255,255,255,0.85)',
                            fontSize: 13,
                            fontWeight: location.pathname === child.path ? 500 : 400,
                            opacity: openKeys.includes(item.key) ? 1 : 0,
                            transform: openKeys.includes(item.key) ? 'translateX(0)' : 'translateX(-10px)',
                            transition: `all 0.25s ease ${idx * 0.05}s`,
                            borderBottom: '1px solid rgba(255,255,255,0.05)',
                          }}
                          onMouseEnter={(e) => {
                            if (location.pathname !== child.path) {
                              e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
                              e.currentTarget.style.color = 'white';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (location.pathname !== child.path) {
                              e.currentTarget.style.background = 'transparent';
                              e.currentTarget.style.color = 'rgba(255,255,255,0.85)';
                            }
                          }}
                        >
                          {child.icon && <span style={{ marginRight: 8, opacity: 0.7 }}>{child.icon}</span>}
                          {child.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </Sider>
      )}
      
      <Layout style={{ flex: 1, overflow: 'hidden' }}>
        {/* 顶部Header - 监测模式下完全隐藏 */}
        {!isMonitorMode && (
        <Header className="dashboard-header" style={{ background: token.colorBgContainer, padding: 0, height: 64, flexShrink: 0 }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            padding: '10px 16px 0 16px',
            position: 'relative',
            height: '100%'
          }}>
            {!isMonitorMode && (
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => {
                  const newCollapsed = !collapsed;
                  setCollapsed(newCollapsed);
                  localStorage.setItem('sidebarCollapsed', newCollapsed.toString());
                }}
                style={{
                  fontSize: '16px',
                  width: 36,
                  height: 36,
                  marginRight: 10,
                }}
              />
            )}
            
            <div style={{ 
              flex: 1, 
              overflow: 'visible',
              position: 'relative',
              paddingRight: 20,
              minHeight: 40,
              display: 'flex',
              alignItems: 'center',
            }}>
              {/* 自定义标签组件 - 高度与用户名统一 - 监测模式下隐藏 */}
              {!isMonitorMode && (
              <div style={{
                width: '100%',
                display: 'block',
                padding: '2px 0 0 0',
                borderBottom: `1px solid ${token.colorBorder}`,
                background: token.colorBgContainer,
                height: '32px',
              }}>
                <div style={{
                  display: 'block',
                  width: '100%',
                }}>
                  {tabs.map((tab, index) => (
                    <div
                      key={tab.key}
                      onClick={async () => {
                        const findMenuItemByPath = (items, targetPath) => {
                          for (const item of items) {
                            if (item.path === targetPath) return item;
                            if (item.children) {
                              const found = findMenuItemByPath(item.children, targetPath);
                              if (found) return found;
                            }
                          }
                          return null;
                        };

                        const menuItem = findMenuItemByPath(processedMenuItems, tab.key);
                        if (menuItem && menuItem.apiUrl) {
                          try {
                            setLoading(true);
                            const response = await apiClient.get(menuItem.apiUrl, {
                              params: menuItem.apiParams || {}
                            });
                            console.log('API Response:', response.data);
                          } catch (error) {
                            console.error('API Error:', error);
                            message.error('获取数据失败');
                          } finally {
                            setLoading(false);
                          }
                        }

                        setActiveTab(tab.key);
                        navigate(tab.key);
                      }}
                      style={{
                        display: 'inline-block',
                        verticalAlign: 'top',
                        padding: '4px 10px',
                        marginRight: '2px',
                        fontSize: 13,
                        cursor: 'pointer',
                        background: activeTab === tab.key ? customTheme.token.colorPrimary : '#f5f5f5',
                        color: activeTab === tab.key ? 'white' : 'rgba(0,0,0,0.65)',
                        borderRadius: '4px 4px 0 0',
                        border: activeTab === tab.key ? `1px solid ${customTheme.token.colorPrimary}` : '1px solid #d9d9d9',
                        borderBottom: activeTab === tab.key ? 'none' : '1px solid #d9d9d9',
                        position: 'relative',
                        maxWidth: 140,
                        height: '30px',
                        lineHeight: '22px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <span style={{ marginRight: (tab.key !== '/venue/dashboard' && tab.key !== '/venue/monitor') ? 16 : 0 }}>
                        {tab.label}
                      </span>
                      {(tab.key !== '/venue/dashboard' && tab.key !== '/venue/monitor') && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            const newTabs = tabs.filter(t => t.key !== tab.key);
                            setTabs(newTabs);
                            localStorage.setItem('tabs', JSON.stringify(newTabs));

                            if (tab.key === activeTab) {
                              if (newTabs.length > 0) {
                                const nextTab = newTabs[Math.max(0, index - 1)];
                                setActiveTab(nextTab.key);
                                localStorage.setItem('activeTab', nextTab.key);
                                navigate(nextTab.path);
                              } else {
                                // 根据当前模式选择默认跳转页面
                                const defaultTab = isMonitorMode 
                                  ? { key: '/venue/monitor', label: '大屏展示', path: '/venue/monitor' }
                                  : { key: '/venue/dashboard', label: '大屏展示', path: '/venue/dashboard' };
                                setTabs([defaultTab]);
                                setActiveTab(defaultTab.key);
                                localStorage.setItem('tabs', JSON.stringify([defaultTab]));
                                localStorage.setItem('activeTab', defaultTab.key);
                                navigate(defaultTab.path);
                              }
                            }
                          }}
                          style={{
                            position: 'absolute',
                            right: 2,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: 14,
                            height: 14,
                            lineHeight: '14px',
                            textAlign: 'center',
                            borderRadius: '50%',
                            fontSize: 11,
                            cursor: 'pointer',
                            opacity: 0.8,
                          }}
                        >
                          ×
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              )}
            </div>
          </div>
          {/* 用户信息区域 - 使用 antd Button + Dropdown 支持遥控器焦点 - 监测模式下隐藏 */}
          {!isMonitorMode && (
          <div style={{
            position: 'absolute',
            right: 16,
            top: 0,
            zIndex: 10,
            height: '32px',
            display: 'flex',
            alignItems: 'center',
          }}>
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'theme',
                    label: (
                      <span>
                        <span style={{ marginRight: 8 }}>🎨</span>主题设置
                      </span>
                    ),
                    onClick: () => setThemeModalVisible(true),
                  },
                  {
                    key: 'profile',
                    label: (
                      <span>
                        <span style={{ marginRight: 8 }}>👤</span>个人资料
                      </span>
                    ),
                    onClick: () => setProfileModalVisible(true),
                  },
                  {
                    key: 'logout',
                    label: (
                      <span style={{ color: '#ff4d4f' }}>
                        <span style={{ marginRight: 8 }}>🚪</span>退出登录
                      </span>
                    ),
                    onClick: handleLogout,
                  },
                ],
              }}
              placement="bottomRight"
            >
              <Button type="text" style={{ padding: '4px 12px' }}>
                <span style={{ 
                  display: 'inline-block', 
                  verticalAlign: 'middle', 
                  fontSize: 13,
                  color: 'rgba(0,0,0,0.85)'
                }}>
                  {user?.name}
                </span>
                <span style={{ 
                  display: 'inline-block', 
                  verticalAlign: 'middle', 
                  marginLeft: 4,
                  fontSize: 10,
                  color: 'rgba(0,0,0,0.45)'
                }}>
                  ▼
                </span>
              </Button>
            </Dropdown>
          </div>
          )}
        </Header>
        )}
        
        <Content className="dashboard-content" style={{ overflowY: 'auto', flex: 1, padding: isMonitorMode ? 0 : undefined }}>
          <div style={{
            overflowX: 'hidden',
            width: '100%',
            maxWidth: '100%',
            position: 'relative',
            zIndex: 1,
            height: '100%'
          }}>
            {loading ? (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%'
              }}>
                <Spin size="large" />
              </div>
            ) : (
              tabs.map(tab => (
                tab.key === activeTab && (
                  <div key={tab.key} style={{ 
                    display: tab.key === activeTab ? 'block' : 'none',
                    minHeight: '100%',
                    padding: isMonitorMode ? 0 : '16px',
                    height: isMonitorMode ? '100vh' : 'auto'
                  }}>
                    <Routes>
                      <Route path="/venue/dashboard" element={<VenueDashboard user={user} />} />
                      <Route path="/venue/monitor" element={<VenueMonitor user={user} />} />
                      <Route path="/portal/list" element={<portalList user={user} />} />
                      <Route path="/portal/add" element={<portalAdd user={user} />} />
                      <Route path="/teams/list" element={<TeamsList user={user} />} />
                      <Route path="/teams/add" element={<TeamsAdd user={user} />} />
                      <Route path="/matches/list" element={<MatchesList user={user} />} />
                      <Route path="/matches/schedule" element={<MatchesSchedule user={user} />} />
                      <Route path="/players/list" element={<PlayersList user={user} />} />
                      <Route path="/players/add" element={<PlayersAdd user={user} />} />
                      <Route path="/statistics/overview" element={<StatisticsOverview user={user} />} />
                      <Route path="/statistics/reports" element={<StatisticsReports user={user} />} />
                      <Route path="/settings/profile" element={<SettingsProfile user={user} />} />
                      <Route path="/settings/system" element={<SettingsSystem user={user} />} />
                      <Route path="/coach/list" element={<TeacherList user={user} />} />
                      <Route path="/member/list" element={<MemberList user={user} />} />
                      <Route path="/teacher/list" element={<TeacherList user={user} />} />
                      <Route path="/student/archive" element={<StudentArchive user={user} />} />
                      <Route path="/customer/list" element={<CustomerList user={user} />} />
                      <Route path="/classperiod/list" element={<Classperiod user={user} />} />
                      <Route path="/academic/list" element={<Academic user={user} />} />
                      <Route path="/course/list" element={<Course user={user} />} />
                      <Route path="/course/pricing" element={<CurriculumSystem user={user} />} />
                      <Route path="/my/course" element={<MyCourse user={user} />} />
                      {/* 社群互动 */}
                      <Route path="/community/list" element={<Community user={user} />} />
                      {/* 学员档案 */}
                      <Route path="/student/profile" element={<StudentProfile user={user} />} />
                      {/* 阶段测评 */}
                      <Route path="/stage/evaluation" element={<StageEvaluation user={user} />} />
                      {/* AI学习 */}
                      <Route path="/ai/learning" element={<AiLearning user={user} />} />
                      {/* 资讯发布 */}
                      <Route path="/bulletin/board" element={<BulletinBoard user={user} />} />
                      {/* 星级课时费 */}
                      <Route path="/star/price" element={<StarPrice user={user} />} />
                      {/* 训练教案 */}
                      <Route path="/training/plan" element={<TrainingPlan user={user} />} />
                      {/* 任务发布 */}
                      <Route path="/event/publish" element={<EventPublish user={user} />} />
                      {/* 任务完成状态 */}
                      <Route path="/event/complete" element={<EventComplete user={user} />} />
                      <Route path="/schedu/course" element={<ScheduCourse user={user} />} />
                      <Route path="/member/archive/:babyId" element={<StudentArchive user={user} />} />
                      {/*<Route path="/" element={<Navigate to={isMonitorMode ? '/venue/monitor' : '/venue/dashboard'} replace />} />*/}
                    </Routes>
                  </div>
                )
              ))
            )}
          </div>
        </Content>
      </Layout>

      {/* 主题设置模态框 */}
      <Modal
        title="主题设置"
        open={themeModalVisible}
        onCancel={() => setThemeModalVisible(false)}
        footer={null}
        width={400}
      >
        <Radio.Group 
          value={currentTheme} 
          onChange={(e) => handleThemeChange(e.target.value)}
          style={{ width: '100%' }}
        >
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
            {getAvailableThemes().map(theme => (
              <Radio.Button 
                key={theme.key} 
                value={theme.key}
                style={{ 
                  textAlign: 'center',
                  height: 'auto',
                  padding: '12px',
                  border: currentTheme === theme.key ? `2px solid ${theme.color}` : '1px solid #d9d9d9'
                }}
              >
                <div style={{ 
                  width: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: theme.color,
                  margin: '0 auto 8px'
                }} />
                <div>{theme.name}</div>
              </Radio.Button>
            ))}
          </div>
        </Radio.Group>
        <div style={{ marginTop: 16, textAlign: 'center', color: '#666', fontSize: 12 }}>
          提示：主题切换后需要刷新页面才能完全生效
        </div>
      </Modal>
      
      {/* 个人资料模态框 */}
      <Modal
        title="个人资料"
        open={profileModalVisible}
        onCancel={() => {
          setProfileModalVisible(false);
          setShowPasswordChangeOnLoad(false);
        }}
        footer={null}
        width={500}
      >
        <Tabs defaultActiveKey={showPasswordChangeOnLoad ? "password" : "profile"} items={[
          {
            key: 'profile',
            label: '个人资料',
            children: <SettingsProfile user={user} />,
          },
          {
            key: 'password',
            label: '修改密码',
            children: <ChangePassword user={user} />,
          },
        ]} />
      </Modal>
    </Layout>
  );
};

export default Dashboard;

